// extracted by mini-css-extract-plugin
module.exports = {"searchButton":"SearchHeaderButton_searchButton__yULrS","searchIcon":"SearchHeaderButton_searchIcon__qpwFt"};